import { useQuery, ApolloError } from '@apollo/client';
import { Channel } from '@ab-core/graphql/dist';
import { CHANNELS } from '@ab-core/hooks';

type Data = {
    pickupChannels?: Channel[];
};
type UseChannelsType = {
    channels?: Channel[];
    channelsError?: ApolloError;
    channelsLoading: boolean;
};
const useChannels = (): UseChannelsType => {
    const { data, error, loading } = useQuery<Data>(CHANNELS);

    const COLLECTION_WAREHOUSE_FREIBURG = '11';
    const MINUS_ONE = -1;

    const channelsToSort = data?.pickupChannels ? [...data.pickupChannels] : [];

    channelsToSort.sort((a: Channel, b: Channel) =>
        a.key === COLLECTION_WAREHOUSE_FREIBURG ||
        ((a?.name || '') < (b?.name || '') && b.key !== COLLECTION_WAREHOUSE_FREIBURG)
            ? MINUS_ONE
            : 1
    );

    return { channels: channelsToSort, channelsError: error, channelsLoading: loading };
};

export default useChannels;
